export const integrationsFr = {
  title: "Intégrations",
  granola: {
    title: "Granola",
    description:
      "Mode API : vos notes Granola arrivent seules dans le CRM toutes les 2 minutes (résumé seulement, jamais la transcription).",
    status: {
      none: "Non connecté",
      connected: "Connecté",
      invalid: "Clé invalide",
      trial_ended: "Essai terminé",
      error: "Erreur",
    },
    connected_on: "Connectée le %{at}. La clé n'est jamais réaffichée.",
    last_sync: "Dernière synchronisation : %{at}",
    first_sync:
      "Première synchronisation dans les 5 minutes (notes des 30 derniers jours).",
    key_label: "Clé API Granola",
    key_help:
      "Dans l'application Granola pour ordinateur : Settings → Connectors → API keys → « Create new key ». Forfait Business ou Enterprise requis.",
    save_key: "Enregistrer la clé",
    disconnect: "Déconnecter Granola",
    sync_now: "Synchroniser maintenant",
    synced_toast: "Synchronisation Granola terminée.",
    confirm_disconnect_title: "Déconnecter Granola ?",
    confirm_disconnect_body:
      "La clé est supprimée. Les notes déjà synchronisées restent dans le CRM.",
    connected_toast: "Granola est connecté.",
    disconnected_toast: "Granola est déconnecté.",
    invalid_help:
      "Clé Granola expirée ou révoquée — retour au collage manuel. Collez une nouvelle clé pour reprendre la synchronisation.",
    trial_ended_help:
      "Votre forfait Granola ne donne plus accès à l'API (essai terminé ?) — retour au collage manuel. Reconnectez une clé quand le forfait le permet.",
    error_help:
      "La synchronisation Granola a échoué. Elle réessaie toute seule ; le collage manuel reste disponible.",
    manual_always:
      "Le collage manuel (« Ajouter des notes Granola » sur une compagnie, un deal ou dans Réunions) reste toujours disponible.",
    errors: {
      granola_key_format:
        "Ce n'est pas une clé API Granola (elle commence par grn_).",
      granola_key_invalid: "Clé invalide : Granola l'a refusée.",
      granola_plan_required:
        "Votre forfait Granola ne donne pas accès à l'API (Business ou Enterprise requis).",
      granola_rate_limited: "Granola est occupé. Réessayez dans une minute.",
      granola_sync_too_soon:
        "Une synchronisation vient d'être lancée. Réessayez dans une minute.",
      granola_sync_failed:
        "La synchronisation Granola a échoué. Réessayez plus tard.",
      granola_not_connected: "Granola n'est pas connecté.",
      granola_too_many_attempts:
        "Trop d'essais de clé. Réessayez dans 10 minutes.",
      granola_unavailable: "Granola ne répond pas. Réessayez plus tard.",
      unauthorized: "Session expirée. Reconnectez-vous au CRM.",
      network: "Erreur réseau. Réessayez.",
      unknown: "La connexion à Granola a échoué.",
    },
  },
  granola_partners: {
    title: "Partenaires et consultants",
    hint: "Une entrée par ligne : un domaine (mnp.ca), une adresse (nom@gmail.com) ou un numéro de téléphone. Une réunion Granola où il n'y a que des collègues ou des partenaires va directement dans « Internes ».",
    label: "Liste",
    save: "Enregistrer",
    saved: "Liste enregistrée.",
    save_failed: "La liste n'a pas pu être enregistrée.",
    error_line: "Ligne %{line} (« %{text} ») : %{reason}",
    reasons: {
      invalid: "ni un domaine, ni une adresse, ni un numéro",
      free_mail_domain:
        "domaine de courriel gratuit — indiquez l'adresse complète",
      too_many: "200 entrées au maximum",
    },
  },
  api_keys: {
    title: "Clés API",
    help: "Pour la plateforme Gavion et Gala. Une clé n'est affichée qu'une seule fois.",
    create: "Créer une clé",
    name: "Nom",
    scopes: "Permissions",
    prefix: "Clé",
    last_used: "Dernière utilisation",
    created: "Créée le",
    never: "Jamais",
    revoke: "Révoquer",
    revoked: "Révoquée",
    active: "Active",
    confirm_revoke:
      "Révoquer la clé « %{name} » ? Les appels qui l'utilisent échoueront immédiatement.",
    empty: "Aucune clé API.",
    toast_revoked: "Clé révoquée.",
    base_url: "URL de base de l'API",
    scope: {
      contacts_read: "Lire les contacts",
      contacts_write: "Créer et modifier les contacts",
      activities_write: "Journaliser des activités",
      deals_write: "Créer des deals",
      webhooks_manage: "Gérer les webhooks",
      jobs_read: "Lire les postes publiés (site Web)",
      jobs_write: "Envoyer des candidatures (site Web)",
    },
  },
  secret_once: {
    title: "Copiez cette valeur maintenant",
    help: "Elle ne sera plus jamais affichée.",
    copy: "Copier",
    copied: "Copié.",
    copy_failed:
      "Copie impossible : sélectionnez la valeur et copiez-la à la main.",
    done: "J'ai copié la valeur",
  },
  webhooks: {
    title: "Webhooks sortants",
    help: "Le CRM envoie des événements signés (HMAC SHA-256) vers ces adresses.",
    create: "Ajouter un point de terminaison",
    url: "URL (https)",
    events: "Événements",
    enabled: "Actif",
    disabled: "Désactivé",
    enable: "Activer",
    disable: "Désactiver",
    failures: "Échecs consécutifs",
    last_success: "Dernier succès",
    delete: "Supprimer",
    confirm_delete: "Supprimer ce point de terminaison ?",
    empty: "Aucun webhook.",
    url_invalid:
      "L'URL doit commencer par https:// et pointer vers un serveur public.",
    url_errors: {
      https_required: "L'URL doit commencer par https://.",
      credentials_not_allowed:
        "L'URL ne doit pas contenir d'identifiants (utilisateur:mot de passe).",
      port_not_allowed: "Le port doit être le port https par défaut (443).",
      host_not_allowed: "Ce nom d'hôte n'est pas autorisé.",
      private_address: "L'URL ne peut pas pointer vers une adresse privée.",
    },
    event: {
      lead_created: "Compagnie créée",
      lead_updated: "Compagnie modifiée",
      call_logged: "Appel journalisé",
      demo_booked: "Démo réservée",
      deal_stage_changed: "Étape du deal modifiée",
      deal_won: "Deal gagné",
      deal_lost: "Deal perdu",
      contact_unsubscribed: "Désabonnement",
      contact_do_not_call: "Ne pas appeler",
    },
  },
  inbound: {
    title: "Webhook entrant Gala",
    help: "Les compagnies captées par Gala arrivent ici quand le propriétaire choisit le CRM « Generic webhook » dans les paramètres de la plateforme Gavion et y colle cette URL et ce secret.",
    url: "URL à configurer",
    status_on: "Actif",
    status_off: "Inactif",
    enable: "Activer",
    disable: "Désactiver",
    rotate: "Générer un nouveau secret",
    confirm_rotate:
      "Générer un nouveau secret ? L'ancien cessera de fonctionner immédiatement.",
    secret_set: "Secret défini le %{date}",
    no_secret: "Aucun secret",
    last_received: "Dernière réception",
    never: "Jamais",
    copy_url: "Copier l'URL",
    url_copied: "URL copiée.",
    signature_title: "Signature des appels",
    signature_help:
      "En-tête X-Gavion-Signature: sha256=<hex>, un HMAC-SHA256 calculé avec ce secret sur les octets exacts du corps brut, envoyé sans modification. L'occurred_at signé doit dater d'au plus 24 h et ne pas être à plus de 5 min dans le futur, sinon 401 stale_request. Le CRM déduplique sur le SHA-256 du corps brut : un renvoi identique répond replayed: true.",
    runbook: "Procédure complète : docs/runbooks/gala-inbound.md",
  },
  errors: {
    forbidden: "Accès refusé.",
    admin_only: "Réservé aux administrateurs.",
    invalid_name: "Donnez un nom (100 caractères au maximum).",
    invalid_scopes: "Choisissez au moins une permission.",
    invalid_url:
      "L'URL doit commencer par https:// et pointer vers un serveur public.",
    invalid_events: "Choisissez au moins un événement.",
    secret_missing: "Générez d'abord un secret.",
    not_found: "Élément introuvable.",
    unknown: "Une erreur est survenue. Réessayez.",
  },
};
